import axios from 'axios'
import { API_URL } from '@/constants'

declare global {
  interface Window {
    Clerk?: {
      session?: { getToken: () => Promise<string | null> }
    }
  }
}

// Single instance for the whole app. The auth token is read from Clerk's global
// at request time rather than injected from React, so this module has no render
// lifecycle and its exported functions keep a constant identity — safe to use in
// effect dependency arrays and in non-React code.
//
// Every caller sits behind the `_auth` route guard (`<SignedIn>`) or a
// `isSignedIn` check, so `window.Clerk.session` is populated by the time a
// request goes out. Requests made before Clerk loads are sent unauthenticated,
// exactly as they were when the token came back null.
export const api = axios.create({
  baseURL: API_URL,
  timeout: 20000,
})

api.interceptors.request.use(
  async config => {
    if (!config.headers.Authorization) {
      const token = await window.Clerk?.session?.getToken()
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    }

    return config
  },
  error => Promise.reject(error)
)
